module.exports = __webpack_public_path__ + "static/media/is_panoramic_glazing.7955df39.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features/is_panoramic_glazing.svg
// module id = 1431
// module chunks = 0